import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import {
  getSelectedOption,
  getSelectedOptions,
  localDate,
  localTime,
  showLocalDate,
} from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import { AgGridReact } from "ag-grid-react";
import Label from "../../../components/elements/form/fromLabel";
import { Link } from "react-router-dom";
import CreateAssetsModal from "../../WorkRequest/_components/createAssets.modal";
import moment, { Moment } from "moment";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Icon from "../../../components/icons";
import CreateSparePartsModal from "./createSpeareParts.modal";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import CreateCheckListsModal from "./createCheckList.modal";
import { useCycleCountApi } from "../../../store/api/hooks/cycleCountApiHook";
import { useMaintenanceCalendarApi } from "../../../store/api/hooks/maintenanceCalendarApiHook";
import { schedulerFrequecyEnum } from "../../../_common/constant";
import Loader from "../../../components/loader";

interface AssetsFormProps {
  _ref?: any;
  WrID?: any;
  prefillData?: any;
  editData?: any;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateSchedulerFormValueType = {
  schedulerID: any;
  schedulerCode: string;
  schedulerStatusID: any;
  planStartDate: Date;
  startTime: Option | undefined;
  planEndDate: Date;
  endTime: Option | undefined;
  priorityID: any;
  facilityID: Option;
  subFacilityIDs: any;
  description: string;
  notes: string;
  departmentID: any;
  assignmentTypeID: any;
  technicialID: any;
  frequencyID: any;
  planID: any;
  schedulerUserMapping: [{ userID: 0 }];
  schedulerAssetMapping: [{ assetID: 0 }];
  schedulerCheckListMapping: [{ checkListID: 0 }];
  schedulerSpareParts: [
    {
      schedulerSparePartMappingID: 0;
      assetID: 0;
      pickedQty: 0;
      sparePartID: 0;
      requiredQty: 0;
      facilityID: 0;
      subFaclityID: 0;
      isPicked: true;
    }
  ];
  assetImage: any;
  every: string;
  timeSlotIDs: any[];
};

const CreateScheduler: React.FC<AssetsFormProps> = ({
  _ref,
  WrID = null,
  prefillData = null,
  editData,
  onCreate = () => { },
  onCancel = () => { },
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
    watch,
    getValues,
  } = useForm<CreateSchedulerFormValueType>({
    defaultValues: {
      schedulerStatusID: 1,
      planID: null,
      timeSlotIDs: [],
    },
  });

  const { showLoader, hideLoader } = useAppLoader();
  const [schedulerCode, setSchedulerCode] = useState<any>(null);
  const [facilityoption, setFacilityoption] = useState<any>([]);
  const [priority, setPriority] = useState<any>([]);
  const [statusList, setStatusList] = useState<any>([]);
  const [assigntypeList, setAssigntypeList] = useState<any>([]);
  const [departmentList, setDepartmentList] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);
  const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
  const [selectedAssets, setSelectedAssets] = useState<any>([]);
  const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
  const [CheckList, setCheckList] = useState<any[]>([]);
  const [workStatus, setWorkStatus] = useState<boolean>(false);
  const [partsAttachment, setPartsAttachment] = useState<any>(null);
  const [isMultiTechnicial] = useState<boolean>(true);
  const [technicianlabel] = useState<string>(`Assigned User`);
  const [deletedCheckList, setDeletedCheckList] = useState<any>([]);
  const [technicianRequired, setTechnicianRequired] = useState<boolean>(false);
  const [scheduleRequired, setScheduleRequired] = useState<boolean>(false);
  const [rowData, setRowData] = useState<any>([]);
  const [SparePartsData, setSparePartsData] = useState<any>([]);
  const [selectedFrequency, setSelectedFrequency] = useState<any>({
    label: "Daily",
    value: 1,
    name: "Day",
  });
  const [frequencyOptions, setFrequencyOptions] = useState<Array<any>>([]);
  const [rawSchedulerData, setRawSchedulerData] = useState<any>(null);
  const [schedulerLoader, setSchedulerLoader] = useState<boolean>(true);
  const [schedulerTypes, setSchedulerTypes] = useState<Array<any>>([]);
  const [timeSlots, setTimeSlots] = useState<Array<any>>([]);
  // const [CheckListsData, setCheckListsData] = useState<any>([]);
  // const [rawEditdata, setRawEditdata] = useState<any>(null);

  // const assigntypeWatcher = watch("assignmentTypeID");
  // const technicianWatcher = watch("technicialID");
  const facilityWatch = watch("facilityID");
  const subFacilityWatch = watch("subFacilityIDs");
  const planWatch = watch("planID");
  const planStartDateWatch = watch("planStartDate");
  const planEndDateWatch = watch("planEndDate");
  const startTimeWatch = watch("startTime");
  const endTimeWatch = watch("endTime");

  const commonApi: any = useCommonApi();
  const workOrderAPI: any = useWorkOrderApi();
  const workRequestAPI: any = useWorkRequestApi();
  const checklistAPI: any = useChecklistApi();
  const assetApi: any = useAssetsApi();
  const facilityApi: any = useFacilitiesApi();
  const cycleApi: any = useCycleCountApi();
  const maintenanceCalendarApi = useMaintenanceCalendarApi();

  const users = useFacilityManagersSelector();

  const createAssetModalRef: any = useRef();
  const createSparePartsModalRef: any = useRef();
  const createCheckListModalRef: any = useRef();

  const gridRef = useRef<AgGridReact | null>(null);

  let imgExt = [".png", ".jpg", ".jpeg", ".webp"];

  // Generate time options in 15-minute intervals
  const generateTimeOptions = () => {
    const times: Option[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = moment().hour(hour).minute(minute).second(0).millisecond(0);
        times.push({
          label: time.format('hh:mm A'),
          value: time.format('HH:mm:ss'),
          data: time
        });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  const columnDefs = [
    {
      headerName: "Asset ID",
      field: "assetCode",
      headerClass: "bg-[#f0f0f0]",
      width: 110,
    },
    {
      headerName: "Asset Name",
      field: "name",
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: (data: any) => {
        return (
          <p
            className="hover:text-primary font-semibold cursor-pointer"
            title={data.value}
          >
            {data.value}
          </p>
        );
      },
    },
    // { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]',  width: 160, cellRenderer:titleCell },
    {
      headerName: "Last Maintenance Date",
      field: "vehicleLastInspection",
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellRenderer: (data: any) => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            {showLocalDate(data.value)}
          </p>
        );
      },
    },
    {
      headerName: "Warranty Expiry Date",
      field: "warrantyEndDate",
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellRenderer: (data: any) => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            {showLocalDate(data.value)}
          </p>
        );
      },
    },
  ];

  const promisifyApi = (apiFunc: any, payload: any) => {
    return new Promise((resolve, reject) => {
      apiFunc(
        payload,
        (resp: any) => resolve(resp),
        (err: any) => reject(err)
      );
    });
  };

  const deleteRow = (params: any) => {
    const rowId = params.data.assetID;
    console.log("fasfaf", params);

    const updatedData = rowData.filter((row: any) => row.assetID !== rowId);
    setRowData(updatedData);
    setSelectedAssets(updatedData);
    console.log("fasfafffdsfds", updatedData);
  };

  const getSchedulerCode = async () => {
    return new Promise((resolve, reject) => {
      // workOrderAPI.GetWOCode(
      maintenanceCalendarApi.getSchedulerCode(
        {},
        (resp: any) => {
          setSchedulerCode(resp.code);
          setValue("schedulerCode", resp.code);
          resolve(resp);
        },
        (error: any) => {
          toast.error(error);
        }
      );
    });
  };

  const getFacilitylist = () => {
    const payload = {};
    facilityApi.getFacilityList(
      payload,
      (resp: any) => {
        let facilitylist: any = [];
        resp.facilityList.map((facilist: any) => {
          facilitylist.push({
            label: facilist.facilityName,
            value: facilist.facilityID,
            data: facilist,
          });
        });
        setFacilityoption(facilitylist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const getsubfacilityList = (_facilityID: any) => {
    setValue("schedulerStatusID", getSelectedOption(1, statusList));
    const payload = { facilityID: _facilityID };
    facilityApi.getSubFacilityList(
      payload,
      (resp: any) => {
        let subfacilityoption: any = resp?.subFacilityList?.map(
          (countylist: any) => {
            return {
              label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
              value: countylist.subFacilityID,
            };
          }
        );

        setsubfacilityoption(subfacilityoption);
        if (editData) {
          const selected: any = editData.subFacilityIDs?.map((subFacID: any) => {
            return {
              label: subfacilityoption.find((subFacOpt: any) => subFacOpt.value === subFacID)?.label,
              value: subFacID,
            }
          });
          setTimeout(() => {
            setValue("subFacilityIDs", selected);
          }, 500);
        }
        //   console.log("prefillData",prefillData);
        if (prefillData?.model?.subFacilityID) {
          // console.log("fsfdsfsfsfsfs",prefillData?.model?.subFacilityID);
          setValue(
            "subFacilityIDs",
            getSelectedOption(
              prefillData?.model?.subFacilityID,
              subfacilityoption
            )
          );
        }
      },
      (error: any) => {
        console.log("error =>", error);
        setsubfacilityoption([]);
        toast.error(error);
      }
    );
  };

  const getPriorityList = () => {
    const payload = {};
    // maintenanceCalendarApi.getPriorityList(
    workRequestAPI.GetPriorityList(
      payload,
      (resp: any) => {
        let facilitylist: any = [];
        // resp.schedulerPriorityList.map((facilist: any) => {
        resp.workRequestPriorityList.map((facilist: any) => {
          facilitylist.push({
            label: facilist.workRequestPriorityName,
            value: facilist.workRequestPriorityID,
            data: facilist,
          });
        });
        setPriority(facilitylist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const getStatusList = () => {
    const payload = {};
    workOrderAPI.GetWOStatusList(
      payload,
      (resp: any) => {
        let deptlist: any = [];

        resp.workOrderStatusList.map((facilist: any) => {
          deptlist.push({
            label: facilist.woStatusName,
            value: facilist.woStatusID,
          });
        });
        setStatusList(deptlist);

        setValue("schedulerStatusID", getSelectedOption(1, deptlist));
        setWorkStatus(true);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const getDepartmentList = () => {
    const payload = {pageSize: 5000,
                pageNumber: 1,};
    assetApi.getAssetdepartment(
      payload,
      (resp: any) => {
        let deptlist: any = [];
        //console.log("resp", resp);
        resp.departmentsList.map((department: any) => {
          deptlist.push({
            label: department.departmentName,
            value: department.departmentID,
          });
        });
        setDepartmentList(deptlist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const GetTechnicianList = (userType:number, facilityID?: number) => {
    console.log("Technician List API called");
    const payload: any = {
      userTypeID: userType
    };
    
    if (facilityID) {
      payload.facilityID = facilityID;
    }
    
    commonApi.GetUserList(payload, (resp: any) => {
      let deptlist: any = [];
      //console.log("resp", resp);
      resp.userList?.map((user: any) => {
        deptlist.push({
          label: user.firstName + " " + user.lastName,
          value: user.userID,
        });
      });
      setUserList(deptlist);
    }, (error: any) => {
      console.log("error =>", error);
      setUserList([]);
      //toast.error(error);
    });
  };

  const getAssignmentTypeList = () => {
    const payload = {};
    workOrderAPI.GetWOAssignmentTypeList(
      payload,
      (resp: any) => {
        let deptlist: any = [];
        resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
          deptlist.push({
            label: assignmentType.woAssignmentTypeName,
            value: assignmentType.woAssignmentTypeID,
          });
        });
        setAssigntypeList(deptlist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const getChecklists = (selectedAssets: any) => {
    let assetIDs: any = [];
    selectedAssets.map((asset: any, index: number) => {
      assetIDs.push(asset.assetID);
    });
    let payload: any = {
      assetIDs: assetIDs,
    };

    checklistAPI.getChecklists(
      payload,
      (resp: any) => {
        console.log("checklist resp =>", resp.checklistList[0]);
        setCheckList(resp.checklistList);
        //setRowData(resp.checklistList ? resp.checklistList : []);
        //  setTotalRecords(resp.totalRecord);
      },
      (error: any) => {
        console.log("error =>", error);
        // toast.error(error);
      }
    );
  };

  const formReset = async () => {
    if (!prefillData) {
      setAttachmentList([]);
      reset({
        planStartDate: undefined,
        planEndDate: undefined,
        description: "",
        notes: "",
        facilityID: null,
        schedulerStatusID: null,
        assetImage: "",
        timeSlotIDs: [],
      });
      setTechnicianRequired(false);
      setScheduleRequired(false);
      await getSchedulerCode().catch((error: any) => { });
      setRowData([]);
      setSelectedAssets([]);
      setCheckList([]);
      setSparePartsData([]);
    }
  };

  const changeAttachmentHandler = (e: any) => {
    setPartsAttachment(e.target.files);
  };

  const onSubmit: SubmitHandler<CreateSchedulerFormValueType> = async (
    data: any
  ) => {
    // console.log("Submit data", data);
    const payload: any = {
      schedulerID: null,
      schedulerCode: null,
      schedulerStatusID: 1,
      planStartDate: null,
      planEndDate: null,
      priorityID: null,
      facilityID: null,
      subFacilityIDs: null,
      description: null,
      notes: null,
      assignmentTypeID: null,
      departmentID: null,
      technicialID: null,
      frequencyID: null,
      every: null,
      growerID: null,
      vendorID: null,
      schedulerAssetMapping: [],
      schedulerUserMapping: [],
      schedulerSpareParts: [],
      schedulerCheckListMapping: [],
      schedulerWalkThroughTimeMapping: [],
    };
    // console.log("Work Request ID is ->", WrID);
    // if (WrID) {
    //   payload.workRequestID = WrID;
    // }

    if (selectedFrequency) {
      payload.frequencyID = selectedFrequency.value;
    }

    for (const index in Object.keys(payload)) {
      var key = Object.keys(payload)[index];
      console.log(key, data[key]);
      if (key in data) {
        payload[key] = data[key];
      }
    }
  const buildSchedulerUserMapping = (technicians: any) => {
    if (!technicians) return [];
    const technicianArr = Array.isArray(technicians) ? technicians : [technicians];
    return technicianArr.map((item: any) => ({ userID: item.value }));
  };
    if (data.assignmentTypeID && typeof data.assignmentTypeID === "object") {
    payload.schedulerUserMapping = buildSchedulerUserMapping(data.technicialID);
      switch (data.assignmentTypeID.value.toString()) {
        case "1": {
          payload.vendorID = null;
          payload.growerID = null;
          break;
        }
        case "2": {
          payload.growerID = data.technicialID.value;
          payload.vendorID = null;
          break;
        }
        case "3": {
          payload.vendorID = data.technicialID.value;
          payload.growerID = null;
          break;
        }
      }
      payload.assignmentTypeID = data.assignmentTypeID.value;
    }
    if (data.departmentID && typeof data.departmentID === "object") {
      payload.departmentID = data.departmentID.value;
    }
    if (data.schedulerStatusID && typeof data.schedulerStatusID === "object") {
      payload.schedulerStatusID = 2; // data.schedulerStatusID.value;
    }
    if (data.facilityID && typeof data.facilityID === "object") {
      payload.facilityID = data.facilityID.value;
    }
    if (data.subFacilityIDs && typeof data.subFacilityIDs === "object") {
      payload.subFacilityIDs = data.subFacilityIDs.map((subFac: any) => subFac.value);
    } else {
      payload.subFacilityIDs = null;
    }
    if (data.priorityID && typeof data.priorityID === "object") {
      payload.priorityID = data.priorityID.value;
    }
    if (data.planID && typeof data.planID === "object") {
      payload.planID = data.planID.value;
      payload.schedulerTypeID = data.planID.schedulerTypeID || data.planID.value;
    }
    // i
    if (data.planStartDate && data.startTime) {
      const timeValue = typeof data.startTime === "object" && data.startTime.value ? data.startTime.value : data.startTime;
      payload.planStartDate = moment(
        moment(data.planStartDate).format(`YYYY-MM-DD`) +
        " " +
        timeValue,
        `YYYY-MM-DD HH:mm:ss`
      )
        .utc()
        .toISOString();
    }
    if (data.planEndDate && data.endTime) {
      const timeValue = typeof data.endTime === "object" && data.endTime.value ? data.endTime.value : data.endTime;
      payload.planEndDate = moment(
        moment(data.planEndDate).format(`YYYY-MM-DD`) +
        " " +
        timeValue,
        `YYYY-MM-DD HH:mm:ss`
      )
        .utc()
        .toISOString();
    }
    // if (data.originalStartDate && data.originalStartTime) {
    //   payload.originalStartDate = moment(
    //     moment(data.originalStartDate).format(`YYYY-MM-DD`) +
    //       " " +
    //       data.originalStartTime.format("HH:mm:ss"),
    //     `YYYY-MM-DD HH:mm:ss`
    //   )
    //     .utc()
    //     .toISOString();
    // }
    // if (data.originalEndDate && data.originalEndTime) {
    //   payload.originalEndDate = moment(
    //     moment(data.originalEndDate).format(`YYYY-MM-DD`) +
    //       " " +
    //       data.originalEndTime.format("HH:mm:ss"),
    //     `YYYY-MM-DD HH:mm:ss`
    //   )
    //     .utc()
    //     .toISOString();
    // }
    if (
      payload.planStartDate &&
      payload.planEndDate &&
      moment
        .utc(payload.planEndDate)
        .diff(moment.utc(payload.planStartDate), "minutes") < 1
    ) {
      return toast.error(
        "End date and time must be greater than start date and time."
      );
    }
    /* if (rowData.length === 0) {
      return toast.error("Please add at least one asset to the Task.");
    } */
    
    // Validate frequency restriction for Walkthrough Plan and planID = 2
    if ((data.planID?.schedulerType?.toLowerCase().includes('walkthrough') || data.planID?.value === 2) && selectedFrequency?.value !== 1) {
      return toast.error("This plan can only use Daily frequency.");
    }
    
    /*
    if (SparePartsData.length === 0) {
      return toast.error("Please add at least one spare part to the Task.");
    }
    */

    const AssData = rowData?.map((item: any) => {
      return {
        assetID: item.assetID,
      };
    });

    const partsData = SparePartsData?.map((itemSpare: any) => {
      // console.log(itemSpare);
      return {
        sparePartID: itemSpare.partsID,
        requiredQty: itemSpare.requiredQty ? itemSpare.requiredQty : 0,
        facilityID: data?.facilityID?.value,
        subFaclityID: data?.subFacilityID?.value
          ? data?.subFacilityID?.value
          : 0,
      };
    });

    const checkListData = CheckList?.map((itemCheck: any) => {
      return {
        checkListID: itemCheck.checkListID,
      };
    });

    const walkThroughTimeData = data.timeSlotIDs?.map((timeSlot: any) => {
      const time = timeSlot.value || timeSlot;
      // Convert time to UTC format
      const utcTime = moment(`1970-01-01 ${time}`, `YYYY-MM-DD HH:mm:ss`).utc().format("HH:mm:ss");
      return {
        walkThroughTime: utcTime,
      };
    }) || [];

    payload.schedulerCheckListMapping = checkListData;
    payload.schedulerWalkThroughTimeMapping = walkThroughTimeData;
    payload.schedulerAssetMapping = AssData;
    payload.schedulerSpareParts = partsData;
    payload.schedulerCode = schedulerCode;
    payload.schedulerID = editData ? editData?.schedulerID : null;
    // if (rawEditdata && rawEditdata.workRequestID) {
    //   payload.workRequestID = rawEditdata.workRequestID;
    // }
    if (
      data.hasOwnProperty(`planStartDate`) &&
      typeof data.planStartDate == "undefined"
    ) {
      payload.planStartDate = null;
    }
    if (
      data.hasOwnProperty(`planEndDate`) &&
      typeof data.planEndDate == "undefined"
    ) {
      payload.planEndDate = null;
    }
    delete payload.technicialID
    console.log("Submit data To scheduler", {
      payload,
      editData,
      data,
      CheckList,
    });

    // return;
    showLoader();
    // workOrderAPI.SaveWorkOrder(
    maintenanceCalendarApi.saveScheduler(
      payload,
      async (resp: any) => {
        // let payloadChecklist: any = {};
        // if (CheckList) {
        //   let taskListarray: any = [];
        //   await new Promise((resolve, reject) => {
        //     payloadChecklist.schedulerID = editData
        //       ? editData?.schedulerID
        //       : resp?.returnID;
        //     CheckList.map((checklist: any, index: number) => {
        //       taskListarray.push(checklist.checkListID);
        //     });
        //     payloadChecklist.checkLists = taskListarray;
        //     workOrderAPI.SaveWorkOrderTaskDetails(
        //       payloadChecklist,
        //       (resp: any) => {
        //         resolve(resp);
        //       },
        //       (error: any) => {
        //         reject(error);
        //       }
        //     );
        //   }).catch((error: any) => {
        //     return null;
        //   });
        // }
        const formData = new FormData();
        formData.append(
          "schedulerID",
          editData ? editData?.schedulerID : resp?.returnID
        );
        if (partsAttachment) {
          var i = 0;
          for await (const partattchment of partsAttachment) {
            formData.append("InputFile" + i, partsAttachment[i]);
            i++;
          }
          /*
          for (let i = 0; i < partsAttachment.length; i++) {
            formData.append("InputFile" + i, partsAttachment[i]);
          }
          */
          const uploadresp: any = await new Promise((resolve, reject) => {
            // workOrderAPI.UploadImage(
            maintenanceCalendarApi.uploadImage(
              formData,
              (resp: any) => {
                resolve(resp);
              },
              (error: any) => {
                toast.error(error);
                reject(error);
              }
            );
          }).catch((error: any) => { });
          if (uploadresp) {
            toast.success(uploadresp?.message);
          }
        } else {
          formReset();
        }
        toast.success(resp?.message);
        onCreate();
        formReset();
        hideLoader();
        console.log(resp, "Submited resp");
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
        hideLoader();
      }
    );
    console.log("Submit payload", payload);
  };

  const getFreuencyOptions = () => {
    setSchedulerLoader(true);
    maintenanceCalendarApi.getFrequencyList(
      {},
      (resp: any, message: string) => {
        let options: any = [];
        resp.schedulerFrequencyList.map((item: any) => {
          options.push({
            label: item.frequencyName,
            value: item.frequencyID,
            name: schedulerFrequecyEnum[
              item?.frequencyName as keyof typeof schedulerFrequecyEnum
            ],
          });
        });
        // console.log("Frequency List", { resp, message, options });
        setFrequencyOptions(options);
        setSchedulerLoader(false);
      },
      (error: any) => {
        console.log("error =>", error);
        setSchedulerLoader(false);
        // toast.error(error);
      }
    );
  };

  const getSchedulerTypes = () => {
    maintenanceCalendarApi.getSchedulerType(
      {},
      (resp: any) => {
        const types = resp.schedulerTypeList?.map((type: any) => ({
          label: type.schedulerType,
          value: type.schedulerTypeID,
          schedulerTypeID: type.schedulerTypeID,
          schedulerType: type.schedulerType
        })) || [];
        setSchedulerTypes(types);
        
        // Set default value to first option if available
        if (types.length > 0 && !editData && !prefillData) {
          setValue("planID", types[0]);
        }
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };

  const generateTimeSlotOptions = () => {
    const slots = [];
    // 12:00 AM (Midnight)
    slots.push({
      label: '12:00 AM',
      value: '00:00:00',
      id: 0
    });
    // AM slots (1:00 AM to 11:00 AM)
    for (let hour = 1; hour <= 11; hour++) {
      slots.push({
        label: `${hour}:00 AM`,
        value: `${hour.toString().padStart(2, '0')}:00:00`,
        id: hour
      });
    }
    // 12:00 PM
    slots.push({
      label: '12:00 PM',
      value: '12:00:00',
      id: 12
    });
    // PM slots (1:00 PM to 11:00 PM)
    for (let hour = 1; hour <= 11; hour++) {
      slots.push({
        label: `${hour}:00 PM`,
        value: `${(hour + 12).toString().padStart(2, '0')}:00:00`,
        id: hour + 12
      });
    }
    setTimeSlots(slots);
  };

  const init_page_date = async () => {
    await getSchedulerCode().catch((error: any) => { });
    getFacilitylist();
    getPriorityList();
    getStatusList();
    getDepartmentList();
    getAssignmentTypeList();
    
    getFreuencyOptions();
    getSchedulerTypes();
    generateTimeSlotOptions();
  };

  const getVendorList = async () => {
    const resp: any = await promisifyApi(commonApi.GetServiceprovidertList, {});
    if (
      resp &&
      resp.hasOwnProperty(`vendorList`) &&
      Array.isArray(resp.vendorList) &&
      resp.vendorList.length > 0
    ) {
      const deptlist = resp.vendorList.map((user: any) => {
        return {
          label: user.name,
          value: user.vendorID,
        };
      });
      setUserList(deptlist);
    }
  };

  const handleOnchangeForFacilitySelection = (SelectOption: any) => {
    if (SelectOption.value != facilityWatch?.value) {
      setValue("subFacilityIDs", null);
      setsubfacilityoption([]);
      setCheckList([]);
      setSparePartsData([]);
      setRowData([]);
      getsubfacilityList(SelectOption.value);
    }
  };

  /* const handleOnchangeForAssigneeTyeSelection = (SelectOption: any) => {
    setTechnicianRequired(true);
    setValue("technicialID", [])
    // setScheduleRequired(true);
    if (SelectOption) {
      switch (SelectOption.value) {
        case 1:
          setTechnicianlabel(`Technician`);
          getTechnicianList();
          break;
        case 2:
          setTechnicianlabel(`Grower`);
          getTechnicianList();
          break;
        case 3:
          setTechnicianlabel(`Vendor`);
          getVendorList();
          break;
      }
    }
    // if (SelectOption?.value !== 1) {
    //   setValue("technicialID", null);
    // }
  }; */

  useEffect(() => {
    init_page_date();
  }, []);

  // Can be required later
  // useEffect(() => {
  //   if (assigntypeWatcher && technicianWatcher) {
  //     setValue(`schedulerStatusID`, getSelectedOption(2, statusList));
  //   } else {
  //     setValue(`schedulerStatusID`, getSelectedOption(1, statusList));
  //   }
  // }, [assigntypeWatcher, technicianWatcher]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
      _ref.current.setValue = setValue;
    }
  }, [_ref]);

  useEffect(() => {
    if (editData == null && !prefillData) {
      formReset();
    }
  }, [editData]);

  useEffect(() => {
    if (facilityWatch) {
      setValue("subFacilityIDs", null);
      getsubfacilityList(facilityWatch.value);
    }
  }, [facilityWatch]);

  // Auto-set planEndDate to 1 month after planStartDate if planEndDate is blank
  useEffect(() => {
    if (planStartDateWatch && !planEndDateWatch && !editData) {
      const endDate = moment(planStartDateWatch).add(1, 'month').toDate();
      setValue("planEndDate", endDate);
    }
  }, [planStartDateWatch]);

  // Auto-set endTime to next 15-minute slot after startTime if endTime is blank
  useEffect(() => {
    if (startTimeWatch && !endTimeWatch && !editData) {
      const currentIndex = timeOptions.findIndex((opt: Option) => opt && opt.value === startTimeWatch.value);
      if (currentIndex !== -1 && currentIndex < timeOptions.length - 1) {
        // Set to next 15-minute slot
        setValue("endTime", timeOptions[currentIndex + 1]);
      } else if (currentIndex === timeOptions.length - 1) {
        // If last slot (23:45), wrap to first slot (00:00)
        setValue("endTime", timeOptions[0]);
      }
    }
  }, [startTimeWatch]);

  useEffect(() => {
    if (prefillData) {
      //console.log("Prefill data is ->", prefillData);
      reset({
        schedulerID: prefillData?.model?.schedulerID,
        schedulerStatusID: getSelectedOption(1, statusList),
        description: prefillData?.model?.description,
        facilityID: getSelectedOption(
          prefillData?.model?.facilityID,
          facilityoption
        ),
        // subFacilityID: getSelectedOption(prefillData?.model?.subFacilityID, subfacilitylist),
        priorityID: getSelectedOption(prefillData?.model?.priorityID, priority),
      });
      setRowData(prefillData?.assets || []);
      setCheckList(prefillData?.checklist || []);
      setAttachmentList(prefillData?.images || []);
    }
  }, [
    prefillData,
    facilityoption,
    users,
    statusList,
    priority,
    assigntypeList,
    userList,
    departmentList,
  ]);

  useEffect(() => {
    if (!editData) return;

    const loadEditData = async () => {
      try {
        const payload = { SchedulerID: editData.schedulerID };

        const resp: any = await promisifyApi(
          maintenanceCalendarApi.getSchedulerByID,
          payload
        );
        if (!resp?.schedulerID) return;

        // Fetch scheduler images
        const schedulerImages = await promisifyApi(
          maintenanceCalendarApi.getSchedulerImages,
          payload
        )
          .then((res: any) => res?.files ?? [])
          .catch(() => []);

        // Optionally fetch work request images if needed
        let attachmentList = [...schedulerImages];
        // if (resp.workRequestID) {
        //   const wrImages = await promisifyApi(workRequestAPI.GetWorkRequestImages, { workRequestID: resp.workRequestID })
        //     .then((res: any) => res?.files ?? [])
        //     .catch(() => []);
        //   attachmentList = [...attachmentList, ...wrImages];
        // }

        // Update raw data only once here
        setRawSchedulerData({ ...resp, attachmentList });
      } catch (error) {
        console.error("Error loading scheduler data:", error);
      }
    };

    loadEditData();
  }, [editData]);

  useEffect(() => {
    if (!rawSchedulerData) return;
    // console.log("Raw Scheduler Data", {rawSchedulerData});
    const transformDataToForm = async () => {
      try {
        const resp = rawSchedulerData;

        setSchedulerCode(resp.schedulerCode);
        setValue("schedulerCode", resp.schedulerCode);

        // Concurrently fetch stock counts
        const updatedPartsList = await Promise.all(
          (resp.schedulerPartsMappingList || []).map(async (part: any) => {
            try {
              const stockResp: any = await promisifyApi(
                cycleApi.GetStockCount,
                {
                  partID: part.partsID,
                  facilityID: resp.facilityID,
                }
              );
              return {
                ...part,
                currenctStock:
                  +stockResp?.currentStock >= 0 ? stockResp.currentStock : 0,
              };
            } catch {
              return { ...part, currenctStock: 0 };
            }
          })
        );

        setSelectedFrequency(
          frequencyOptions?.find(
            (option) => option.value === resp.frequencyID
          ) || frequencyOptions[0]
        );

        const editFormData: any = {
          description: resp.description || "",
          notes: resp.notes || "",
          every: resp.every || "",
          facilityID: getSelectedOption(resp.facilityID, facilityoption),
          schedulerStatusID: getSelectedOption(
            resp.schedulerStatusID,
            statusList
          ),
          priorityID: getSelectedOption(resp.priorityID, priority),
          assignmentTypeID: getSelectedOption(
            resp.assignmentTypeID,
            assigntypeList
          ),
          departmentID: getSelectedOption(resp.departmentID, departmentList),
          planStartDate: localDate(resp.planStartDate),
          planEndDate: localDate(resp.planEndDate),
          startTime: (() => {
            const timeMoment = localTime(resp.planStartDate);
            return timeMoment ? timeOptions.find((opt: Option) => opt && opt.value === timeMoment.format('HH:mm:ss')) : undefined;
          })(),
          endTime: (() => {
            const timeMoment = localTime(resp.planEndDate);
            return timeMoment ? timeOptions.find((opt: Option) => opt && opt.value === timeMoment.format('HH:mm:ss')) : undefined;
          })(),
          technicialID: null, // Will be set based on assignment type
          planID: getSelectedOption(resp.planID, schedulerTypes),
          timeSlotIDs: getSelectedOptions(resp.timeSlotIDs || [], timeSlots),
          // ...(resp.workRequestID ? { workRequestID: resp.workRequestID } : {}),
        };

        // Technician / Vendor assignment handling
        if (
          resp.assignmentTypeID === 1 &&
          Array.isArray(resp.schedulerUserMappingList) &&
          resp.schedulerUserMappingList?.length > 0 &&
          userList?.length > 0
        ) {
          const technicianIDs = resp.schedulerUserMappingList.map(
            (o: any) => o.userID
          );
          editFormData.technicialID = getSelectedOptions(
            technicianIDs,
            userList
          );
          setValue("technicialID", getSelectedOptions(technicianIDs, userList));
        } else if (resp.assignmentTypeID === 3) {
          editFormData.technicialID = getSelectedOption(
            resp.vendorID,
            userList
          );
          const vendorOpt = getSelectedOption(resp.vendorID, userList);
          setValue("technicialID", vendorOpt ? [vendorOpt] : []);
        } else if (resp.assignmentTypeID === 2) {
          editFormData.technicialID = getSelectedOption(
            resp.growerID,
            userList
          );
          const growerOpt = getSelectedOption(resp.growerID, userList);
          setValue("technicialID", growerOpt ? [growerOpt] : []);
        }

        setRowData(resp.schedulerAssetMappingList || []);
        setCheckList(resp.schedulerCheckListMappingList || []);
        setSparePartsData(updatedPartsList);
        setAttachmentList(resp.attachmentList);
        reset(editFormData);
      } catch (error) {
        console.error("Error transforming scheduler data:", error);
      }
    };

    transformDataToForm();
  }, [
    rawSchedulerData,
    facilityoption,
    statusList,
    priority,
    assigntypeList,
    departmentList,
    frequencyOptions,
    schedulerTypes,
    timeSlots,
    // userList,
  ]);

  // useEffect to handle plan selection and frequency restriction
  useEffect(() => {
    if (planWatch?.schedulerType?.toLowerCase().includes('walkthrough') || planWatch?.value === 2) {
      // If Walkthrough Plan or planID = 2 is selected, force Daily frequency
      const dailyFrequency = frequencyOptions.find(option => option.value === 1);
      if (dailyFrequency) {
        setSelectedFrequency(dailyFrequency);
      }
    }
    
    // If planID = 2, set Assignment Type to Grower (value: 2)
    if (planWatch?.value === 2 && assigntypeList.length > 0) {
      const growerOption = assigntypeList.find((option: any) => option.value === 2);
      if (growerOption) {
        setValue("assignmentTypeID", growerOption);
        setTechnicianRequired(true);
        GetTechnicianList(growerOption.value, facilityWatch?.value ? Number(facilityWatch.value) : undefined);
        setValue("technicialID", []);
      }
    }
  }, [planWatch, frequencyOptions, assigntypeList]);

  return (
    <div className={`relative`} ref={_ref}>
      {schedulerLoader && (
        <div
          className={`absolute p-8`}
          style={{
            height: "100%",
            width: "100%",
            zIndex: 2,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
          }}
        >
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={`${schedulerLoader ? `hidden` : `flex`} flex-col`}>
        <div className="flex-1 overflow-auto">
          <h4 className="font-semibold text-[0.938rem] border-gray-200 py-4 uppercase">General</h4>
          {schedulerCode && (
            <div className="bg-green-50 py-2 px-3">
              <h6 className="text-[0.813rem] font-semibold">
                Scheduler Number
              </h6>
              <p className="text-[0.813rem] font-normal mt-2">
                {schedulerCode}
              </p>
            </div>
          )}

          <div className={`h-[0.5rem]`}></div>

          <h4 className="font-semibold text-[0.938rem] border-gray-200 py-4 uppercase">
            Schedule
          </h4>

          <div>
            <div className="mb-6 w-full">
              <div className="flex items-center gap-6 pt-4">
                <p className="font-normal text-[0.938rem] leading-none">Select Plan</p>
                <Controller
                  name="planID"
                  control={control}
                  rules={{ required: "Plan is required" }}
                  render={({ field: { value, onChange } }) => (
                    <div className="flex gap-6 items-center">
                      {schedulerTypes.map((type) => (
                        <label key={type.value} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="radio"
                            name="planID"
                            value={type.value}
                            checked={value?.value === type.value}
                            onChange={() => onChange(type)}
                            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          />
                          <span className="text-sm font-medium text-gray-700">{type.label}</span>
                        </label>
                      ))}
                      {errors.planID?.message && (
                        <p className="text-red-500 text-sm ml-4">{String(errors.planID.message)}</p>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>

            {planWatch?.value === 2 && ( <div className="mb-6 w-full">
              <Controller
                name="timeSlotIDs"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <SelectBox
                    label="Time Slot"
                    value={value}
                    onChange={(selectedOptions: any) => {
                      if (Array.isArray(selectedOptions) && selectedOptions.length <= 5) {
                        // Sort selected options chronologically based on their time values
                        const sortedOptions = selectedOptions.sort((a, b) => {
                          const timeA = a.id || a.value;
                          const timeB = b.id || b.value;
                          return timeA - timeB;
                        });
                        onChange(sortedOptions);
                      } else if (selectedOptions && selectedOptions.length > 5) {
                        toast.error("You can select maximum 5 time slots");
                      }
                    }}
                    isMulti={true}
                    placeholder="Select time slots (max 5)"
                    options={timeSlots}
                    error={errors.timeSlotIDs?.message as any}
                  />
                )}
              />
            </div> )}
            {/* {planWatch?.value === 2 && ( <div className="mb-6 w-full">
              <Controller
                name="timeSlotIDs"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <SelectBox
                    label="Time Slot"
                    value={value}
                    onChange={(selectedOptions: any) => {
                      // Limit to maximum 5 selections
                      if (Array.isArray(selectedOptions) && selectedOptions.length <= 5) {
                        onChange(selectedOptions);
                      } else if (selectedOptions && selectedOptions.length > 5) {
                        toast.error("You can select maximum 5 time slots");
                      }
                    }}
                    isMulti={true}
                    placeholder="Select time slots (max 5)"
                    options={timeSlots}
                    error={errors.timeSlotIDs?.message as any}
                  />
                )}
              />
            </div> )} */}

            <Label text={"Frequency"} isBold={false} />

            <div className="flex mb-3 mt-4 justify-center gap-4 ">
              {frequencyOptions?.map((tab) => {
                const isWalkthroughPlan = planWatch?.schedulerType?.toLowerCase().includes('walkthrough');
                const isPlanID2 = planWatch?.value === 2;
                const isDailyTab = tab.value === 1;
                const isDisabled = (isWalkthroughPlan && !isDailyTab) || (isPlanID2 && !isDailyTab);
                
                return (
                  <button
                    key={tab.value}
                    className={`border px-4 py-2 rounded-lg text-[0.875rem] font-medium w-full ${
                      selectedFrequency?.value === tab.value
                        ? "bg-green-100 text-green-700"
                        : isDisabled
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-white text-gray-700"
                    } ${!isDisabled ? "hover:bg-green-50 transition-colors" : ""}`}
                    type="button"
                    disabled={isDisabled}
                    onClick={() => {
                      if (!isDisabled) {
                        setSelectedFrequency(tab);
                      }
                    }}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <div className="flex items-center gap-2">
              <p className="font-normal text-[0.938rem] leading-none">Every</p>
              <Controller
                name="every"
                rules={{ required: "Every is required" }}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <Input
                    type="number"
                    value={value}
                    onChange={onChange}
                    required
                    placeholder="Enter value"
                    error={errors.every?.message}
                    className="my-0"
                  />
                )}
              />
              <p className="font-normal text-[0.938rem] leading-none">
                {selectedFrequency?.name}
              </p>
            </div>
          </div>

          <Controller
            name="schedulerStatusID"
            defaultValue={getSelectedOption(2, statusList)}
            control={control}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Status"
                value={value}
                onChange={onChange}
                disabled={workStatus}
                placeholder="Choose Status"
                className="mt-0 hidden"
                options={statusList}
                error={errors.schedulerStatusID?.message as any}
              />
            )}
          />
          <div className="grid grid-cols-2 gap-2 relative">
            <Controller
              name="planStartDate"
              control={control}
              rules={{ required: "Planned Start Date is required" }}
              render={({ field: { value, onChange } }) => (
                <Datepicker
                  label="Planned Start Date"
                  minDate={new Date()}
                  required={true}
                  // required={scheduleRequired}
                  value={value}
                  onChange={onChange}
                  error={errors.planStartDate?.message}
                />
              )}
            />
            {planWatch?.value !== 2 && (
              <Controller
                name="startTime"
                rules={{ required: planWatch?.value !== 2 ? "Planned Start Time is required" : false }}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <SelectBox
                    label="Planned Start Time"
                    value={value}
                    onChange={onChange}
                    placeholder="Select Time"
                    options={timeOptions}
                    required={planWatch?.value !== 2}
                    error={errors.startTime?.message as any}
                  />
                )}
              />
            )}
          </div>
          <div className="grid grid-cols-2 gap-2 relative">
            <Controller
              name="planEndDate"
              control={control}
              rules={{ required: "Planned End Date is required" }}
              render={({ field: { value, onChange } }) => (
                <Datepicker
                  label="Planned End Date"
                  required={true}
                  // required={scheduleRequired}
                  minDate={watch("planStartDate") || new Date()}
                  value={value}
                  onChange={onChange}
                  error={errors.planEndDate?.message}
                />
              )}
            />
            {planWatch?.value !== 2 && (<Controller
              name="endTime"
              rules={{ required: planWatch?.value !== 2 ? "Planned End Time is required" : false }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <SelectBox
                  label="Planned End Time"
                  value={value}
                  onChange={onChange}
                  placeholder="Select Time"
                  options={timeOptions}
                  required={planWatch?.value !== 2}
                  error={errors.endTime?.message as any}
                />
              )}
            />)}
          </div>

          <Controller
            name="priorityID"
            control={control}
            rules={{ required: "Priority is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Priority"
                value={value}
                onChange={onChange}
                required
                placeholder="Choose Priority"
                options={priority}
                error={errors.priorityID?.message as any}
              />
            )}
          />

          <Controller
            name="facilityID"
            control={control}
            rules={{ required: "Facility is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Facility"
                required
                value={value}
                onChange={(SelectOption: any) => {
                  onChange(SelectOption);
                  handleOnchangeForFacilitySelection(SelectOption);
                  // if (SelectOption.value != facilityWatch?.value) {
                  //   onChange(SelectOption);
                  //   setValue("subFacilityID", null);
                  //   setsubfacilityoption([]);
                  //   setCheckList([]);
                  //   setSparePartsData([]);
                  //   setRowData([]);
                  //   getsubfacilityList(SelectOption.value);
                  // }
                }}
                placeholder="Choose Facility"
                options={facilityoption}
                error={errors.facilityID?.message as any}
              />
            )}
          />

          <Controller
            name="subFacilityIDs"
            control={control}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Sub Facility"
                onChange={onChange}
                isMulti={true}
                value={value}
                placeholder="Choose Sub Facility"
                options={subfacilitylist}
                error={errors.subFacilityIDs?.message as any}
              />
            )}
          />

          <Controller
            name="description"
            rules={{ required: "Description is required" }}
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Description"
                value={value}
                onChange={onChange}
                required
                placeholder=""
                error={errors.description?.message}
              />
            )}
          />

          <Controller
            name="notes"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Teaxtarea
                label="Notes"
                value={value}
                onChange={onChange}
                placeholder="Possible root cause, spare parts needed, special tools required"
              />
            )}
          />

          <div className="flex justify-between  mb-2 my-6 mx-4 pb-4">
            <Label text={"ASSIGNEE"} isBold={true} />
          </div>

          {/* <Controller
            name="assignmentTypeID"
            control={control}
             rules={{ required: "Assignment is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Assignment Type"
                value={value}
                onChange={(SelectOption: any) => {
                  onChange(SelectOption);
                  handleOnchangeForAssigneeTyeSelection(SelectOption);
                }}
                required
                placeholder="Assignment Type"
                options={assigntypeList}
                error={errors.assignmentTypeID?.message as any}
              />
            )}
          /> */}
          <Controller
            name="assignmentTypeID"
            control={control}
            rules={{ required: "Assignment is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Assignment Type"
                value={value}
                required
                //disabled={planWatch?.value === 2}
                onChange={(SelectOption: any) => {
                  //if (planWatch?.value === 2) return; // Prevent changes when planID is 2
                  
                  setTechnicianRequired(true);
                  onChange(SelectOption);
                  //setScheduleRequired(true);

                  if (SelectOption) {
                    GetTechnicianList(
                      SelectOption.value,
                      facilityWatch?.value ? Number(facilityWatch.value) : undefined
                    );
                  }
                  setValue("technicialID", []);
                  /*
                  if (SelectOption?.value !== 1) {
                    setValue("technicialID", null);
                  }
                  */
                }}
                //   required
                placeholder="Assignment Type"
                options={assigntypeList ? assigntypeList : []}
                error={errors.assignmentTypeID?.message as any}
              />
            )}
          />

          <Controller
            name="technicialID"
            control={control}
            rules={{
              required: technicianRequired ? `This field is required.` : false,
            }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label={technicianlabel}
                isMulti={isMultiTechnicial}
                value={value}
                onChange={onChange}
                required={technicianRequired}
                placeholder="Select Option"
                options={userList}
                error={errors.technicialID?.message as any}
              />
            )}
          />

          <Controller
            name="departmentID"
            control={control}
            rules={{ required: "Department is required" }}
            render={({ field: { value, onChange } }) => (
              <SelectBox
                label="Department"
                value={value}
                onChange={onChange}
                required
                placeholder="Select"
                options={departmentList}
                error={errors.departmentID?.message as any}
              />
            )}
          />

          <div>
            <div className="flex justify-between mb-2 my-6 mx-4 pb-4 ml-0">
              <Label text={"ASSETS"} isBold={true} />
              <p
                className="cursor-pointer text-[0.938rem] text-primary  font-normal"
                onClick={() => {
                  if (facilityWatch) {
                    createAssetModalRef?.current?.showModal();
                    //console.log(findAssetsNewModalRef?.current);
                    //  findAssetsNewModalRef?.current?.show();
                    //setIsOpenAssetModal(true);
                    //findAssetsModalRef?.current?.showModal();
                  } else {
                    toast.error("Please select facility");
                  }
                }}
              >
                Add New Assets
              </p>
            </div>

            <div className={`custom-static-grid`}>
              <div
                className={`custom-static-table`}
                style={{
                  border: `1px solid #043E6133`,
                  borderRadius: `5px`,
                  overflow: `hidden`,
                }}
              >
                <div
                  className={`flex items-center bg-[#f0f0f0]`}
                  style={{ height: `52px` }}
                >
                  <div
                    className={`px-2 py-4 font-medium text-center`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `128px`,
                    }}
                  >
                    Asset ID
                  </div>
                  <div
                    className={`flex-grow px-2 py-4 font-medium`}
                    style={{ fontSize: `13px`, color: `#262A2D` }}
                  >
                    Asset Name
                  </div>
                  <div
                    className={`px-2 py-4 font-medium`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `130px`,
                    }}
                  >
                    Last Maintenance Date
                  </div>
                  <div
                    className={`px-2 py-4 font-medium`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `115px`,
                    }}
                  >
                    Warranty Expiry Date
                  </div>
                  <div
                    className={`px-2 py-4 text-right`}
                    style={{ textAlign: `right`, width: `42px` }}
                  ></div>
                </div>

                {rowData &&
                  rowData?.length > 0 &&
                  rowData.map((asset: any, index: number) => {
                    return (
                      <div
                        key={asset.assetCode}
                        className={`flex items-center`}
                        style={{ borderBottom: `1px solid #043E6133` }}
                      >
                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `128px` }}
                        >
                          {asset.assetCode}
                        </div>
                        <div
                          className={`font-light px-2 py-2 flex-grow`}
                        >
                          {asset.name}
                        </div>
                        <div
                          className={`font-light px-2 py-2`}
                          style={{ width: `130px` }}
                        >
                          {asset.vehicleLastInspection
                            ? moment
                              .utc(asset.vehicleLastInspection)
                              .local()
                              .format(`MM/DD/YY`)
                            : `-`}
                        </div>
                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `115px` }}
                        >
                          {asset.warrantyEndDate
                            ? moment
                              .utc(asset.warrantyEndDate)
                              .local()
                              .format(`MM/DD/YY`)
                            : `-`}
                        </div>
                        <div
                          className={`px-2 py-4 text-right`}
                          style={{ textAlign: `right`, width: `42px` }}
                        >
                          <a
                            className={`text-primary`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to remove this asset?"
                                )
                              ) {
                                rowData.splice(index, 1);
                                setRowData([...rowData]);
                              }
                            }}
                          >
                            <Icon name="cross" size={1} />
                          </a>
                        </div>
                      </div>
                    );
                  })}
                {rowData?.length === 0 && (
                  <div
                    className={`flex items-center justify-center`}
                    style={{ height: `200px`, color: `#262A2D` }}
                  >
                    <p>No assets added yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={`mb-8`}>
            <div className="flex justify-between  mb-2 my-6 mx-4 pb-4  ml-0">
              <Label text={"SPARE PARTS"} isBold={true} />
              <p
                className="cursor-pointer text-[0.938rem] text-primary  font-normal"
                onClick={() => {
                  createSparePartsModalRef?.current?.showModal();
                  /*
                if (facilityWatch) {                  
                  //console.log(findAssetsNewModalRef?.current);
                  //findAssetsNewModalRef?.current?.show();
                  //setIsOpenAssetModal(true);
                  //findAssetsModalRef?.current?.showModal();
                } else {
                  toast.error("Please select facility");
                }
                */
                }}
              >
                Add New Spare Parts
              </p>
            </div>
            <div className={`custom-static-grid`}>
              <div
                className={`custom-static-table`}
                style={{
                  border: `1px solid #043E6133`,
                  borderRadius: `5px`,
                  maxWidth: `673px`,
                  overflow: `hidden`,
                }}
              >
                <div
                  className={`flex items-center bg-[#f0f0f0]`}
                  style={{ height: `52px` }}
                >
                  <div
                    className={`px-2 py-4 font-medium text-center`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `140px`,
                      minWidth: `140px`,
                    }}
                  >
                    Part Code
                  </div>
                  <div
                    className={`flex-grow px-2 py-4 font-medium`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `calc(100% - 407px)`,
                    }}
                  >
                    Part Name
                  </div>
                  <div
                    className={`px-2 py-4 font-medium text-center`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `110px`,
                    }}
                  >
                    Availble QTY
                  </div>
                  <div
                    className={`px-2 py-4 font-medium`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `115px`,
                    }}
                  >
                    Required QTY
                  </div>
                  <div
                    className={`px-2 py-4 text-right`}
                    style={{ textAlign: `right`, width: `42px` }}
                  ></div>
                </div>

                {SparePartsData &&
                  SparePartsData.map((parts: any, index: number) => {
                    return (
                      <div
                        className={`flex items-center`}
                        style={{ borderBottom: `1px solid #043E6133` }}
                      >
                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `140px`, minWidth: `140px` }}
                        >
                          {parts.partsCode}
                        </div>
                        <div
                          className={`font-light px-2 py-2 flex-grow`}
                          style={{
                            width: `calc(100% - 407px)`,
                            whiteSpace: `nowrap`,
                            overflow: `hidden`,
                            textOverflow: `ellipsis`,
                          }}
                        >
                          {parts.sparePartsName}
                        </div>
                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `110px` }}
                        >
                          {Number(parts.currenctStock)}
                        </div>
                        <div
                          className={`font-normal px-2 py-2 text-center`}
                          style={{ width: `115px` }}
                        >
                          <input
                            type="text"
                            placeholder="Enter qty"
                            className={`border-[#CECECE] border rounded-md focus:outline-none focus:primary text-[0.938rem] px-2 py-1  font-normal h-[2rem] text-[#222222] placeholder:text-[#a1a1a1] w-full text-center`}
                            value={parts.requiredQty || ""}
                            onChange={(e: any) => {
                              setSparePartsData(
                                SparePartsData.map((partsc: any, j: number) => {
                                  if (index == j) {
                                    partsc.requiredQty = e.target.value;
                                  }
                                  return partsc;
                                })
                              );
                            }}
                          />
                        </div>
                        <div
                          className={`px-2 py-4 text-right`}
                          style={{ textAlign: `right`, width: `42px` }}
                        >
                          <a
                            className={`text-primary`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to remove this asset?"
                                )
                              ) {
                                SparePartsData.splice(index, 1);
                                setSparePartsData([...SparePartsData]);
                              }
                            }}
                          >
                            <Icon name="cross" size={1} />
                          </a>
                        </div>
                      </div>
                    );
                  })}
                {!SparePartsData ||
                  (SparePartsData && SparePartsData.length < 1 && (
                    <div
                      className={`flex items-center justify-center`}
                      style={{ height: `200px`, color: `#262A2D` }}
                    >
                      <p>No spare parts added yet!</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div>
            <div className="flex justify-between mb-2 my-6 mx-4 pb-4 ml-0">
              <Label text={"Checklist"} isBold={true} />
              <p
                className="cursor-pointer text-[0.938rem] text-primary  font-normal"
                onClick={() => {
                  if (facilityWatch) {
                    createCheckListModalRef?.current?.showModal();
                    //console.log(findAssetsNewModalRef?.current);
                    //  findAssetsNewModalRef?.current?.show();
                    //setIsOpenAssetModal(true);
                    //findAssetsModalRef?.current?.showModal();
                  } else {
                    toast.error("Please select facility");
                  }
                }}
              >
                Add New Checklist
              </p>
            </div>

            <div className={`custom-static-grid`}>
              <div
                className={`custom-static-table`}
                style={{
                  border: `1px solid #043E6133`,
                  borderRadius: `5px`,
                  overflow: `hidden`,
                }}
              >
                <div
                  className={`flex items-center bg-[#f0f0f0]`}
                  style={{ height: `52px` }}
                >
                  <div
                    className={`px-2 py-4 font-medium text-center`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `128px`,
                    }}
                  >
                    Checklist No
                  </div>
                  <div
                    className={`flex-grow px-2 py-4 font-medium`}
                    style={{ fontSize: `13px`, color: `#262A2D` }}
                  >
                    Title
                  </div>
                  <div
                    className={`px-2 py-4 font-medium`}
                    style={{
                      fontSize: `13px`,
                      color: `#262A2D`,
                      width: `130px`,
                    }}
                  >
                    Type
                  </div>

                  <div
                    className={`px-2 py-4 text-right`}
                    style={{ textAlign: `right`, width: `42px` }}
                  ></div>
                </div>

                {CheckList &&
                  CheckList.map((checklist: any, index: number) => {
                    return (
                      <div
                        key={checklist.assetCode}
                        className={`flex items-center`}
                        style={{ borderBottom: `1px solid #043E6133` }}
                      >
                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `128px` }}
                        >
                          {checklist.checkListCode}
                        </div>
                        <div
                          className={`font-light px-2 py-2 flex-grow`}
                        >
                          {checklist.title ?? checklist.checkListTitle}
                        </div>

                        <div
                          className={`font-light px-2 py-2 text-center`}
                          style={{ width: `115px` }}
                        >
                          {checklist.checkListTypeName}
                        </div>
                        <div
                          className={`px-2 py-4 text-right`}
                          style={{ textAlign: `right`, width: `42px` }}
                        >
                          <a
                            href="javascript:void(0);"
                            className={`text-primary`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Are you sure you want to remove this Checklist?"
                                )
                              ) {
                                setDeletedCheckList([
                                  ...deletedCheckList,
                                  checklist.checkListID,
                                ]);
                                CheckList.splice(index, 1);
                                setCheckList([...CheckList]);
                              }
                            }}
                          >
                            <Icon name="cross" size={1} />
                          </a>
                        </div>
                      </div>
                    );
                  })}
                {CheckList.length === 0 && (
                  <div
                    className={`flex items-center justify-center`}
                    style={{ height: `200px`, color: `#262A2D` }}
                  >
                    <p>No Checklist added yet!</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/*
        <FindAssetsModal
          _ref={findAssetsModalRef}
          selected={[]}
          searchfacility={getValues(`facilityID`) || ``}
          searchsubFacility={getValues(`subFacilityID`) || ``}
          onSelect={(data: Array<any>) => {}}
        />
        */}

          <CreateSparePartsModal
            _ref={createSparePartsModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            onContinue={async (selectedSpareparts: any[]) => {
              console.log("Selected Spare Parts", selectedSpareparts);
              createSparePartsModalRef?.current?.close();
              /*
            showLoader();
            if (Array.isArray(selectedSpareparts) && selectedSpareparts.length > 0) {
              for await (const part of selectedSpareparts) {
                part[`currenctStock`] = 0;
                const prespitem:any = await new Promise((resolve, reject) => {
                  cycleApi.GetStockCount({ partID: part.partsID, facilityID: part.facilityID }, (presp:any) => {
                    resolve(presp);
                  }, (error:any) => {
                    console.log("Parts stock error -> " + part.sparePartsName + " -> ", error);
                    reject(null);
                  });
                }).catch((error:any) => {
                  return null;
                });
                if (prespitem && prespitem.hasOwnProperty(`currentStock`) && +prespitem.currentStock >=0) {
                  part[`currenctStock`] = prespitem.currentStock;
                }              
              }            
            }
            hideLoader();
            */
              //  setSparePartsData(selectedSpareparts);
              selectedSpareparts?.map((parts: any) => {
                setSparePartsData((prevData: any) => [
                  ...(Array.isArray(prevData) ? prevData : []), // Spread the existing array
                  parts,
                ]);
              });
            }}
          />

          <CreateCheckListsModal
            _ref={createCheckListModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            planWatch={planWatch?.value}
            deletedCheckList={deletedCheckList}
            onContinue={(selectedCheckList: any[]) => {
              console.log("Selected Cehck List", selectedCheckList);
              let arrcheck: any = [];
              if (CheckList.length > 0) {
                CheckList.map((checklist: any, index: number) => {
                  arrcheck.push(checklist);
                });
              }
              if (selectedCheckList.length > 0) {
                selectedCheckList.map((checklist: any, index: number) => {
                  arrcheck.push(checklist);
                });
              }

              setCheckList(arrcheck);
              createCheckListModalRef?.current?.close();
            }}
          />

          <CreateAssetsModal
            _ref={createAssetModalRef}
            facility={facilityWatch}
            subFacility={subFacilityWatch}
            onContinue={(selectedAssets: any[]) => {
              console.log("Selected Assets", selectedAssets);
              //setValue("assets", selectedAssets);
              getChecklists(selectedAssets);
              setSelectedAssets(selectedAssets);
              setRowData(selectedAssets);
              createAssetModalRef?.current?.close();
            }}
          />

          <Controller
            name="assetImage"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FileUpload
                label="Upload Picture"
                value={value}
                isMulti={true}
                accept=".jpg, .jpeg, .png"
                isFigmaType={true}
                allowedExt={[`png`, `jpg`, `jpeg`, `gif`]}
                onChange={(e: any, files: any) => {
                  changeAttachmentHandler(e);
                  onChange(e.target.files[0]);
                }}
                placeholder="Choose Processing Facility"
              />
            )}
          />
          {attachmentList && attachmentList.length > 0 && (
            <div>
              <h4 className="font-semibold text-[0.938rem] pb-4 uppercase">
                Files
              </h4>
              <div className="grid grid-cols-5 gap-3">
                {attachmentList.map((item: any, index: number) => {
                  const found = imgExt.some((word) =>
                    item.originalFileName.includes(word)
                  );
                  return (
                    <div
                      key={`attachmentList${index}`}
                      className="border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative"
                    >
                      <Link to={item.fullFilePath} target="_blank">
                        {found ? (
                          <img
                            src={item.fullFilePath}
                            alt={item.originalFileName}
                            className="max-w-full max-h-20"
                          />
                        ) : (
                          item.originalFileName
                        )}
                      </Link>
                      {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
          <Button
            type="button"
            theme="secondary"
            onClick={() => {
              formReset();
              onCancel();
            }}
          >
            Cancel
          </Button>
          {/* disabled={selectedAssets.length == 0 ? true : false} */}
          <Button type="submit">Save</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateScheduler;
